module.exports = __webpack_public_path__ + "static/media/file_pin.2c553e26.ico";